import df from '../utils/DateFormat';
import { publish } from '../utils/pubsub';
import { events } from './SystemEvents';
import config from '../../config.json';

const isProd = config.appMode === 'PROD';

let _logCtx = null;

class LogService {
    initialize = (logCtx) => {
        if (_logCtx !== null) return;
        _logCtx = logCtx;
    };

    log = (msg) => {
        if (isProd) return;

        const doLog = _logCtx === null ? true : _logCtx.doLogMessage;
        if (!doLog) return;

        const s = this.getTime();
        console.log(`${s}: Info -${msg}`);
    };

    logError = (msg) => {
        const s = this.getTime();
        const logMsg = `${s}: Error - ${msg}`;

        // Publish for LogEngine to pick up — always, also in PROD
        publish(events.onLogCreated, { level: 'error', msg: logMsg, ts: Date.now() });

        if (isProd) return;

        const doLog = _logCtx === null ? true : _logCtx.doLogError;
        if (!doLog) return;

        console.log(logMsg);
    };

    getTime = () => {
        const date = Date.now();
        return df.epochToDateStr(date / 1000, 'yyyymmdd HH:MM:ss');
    };
}

const logService = new LogService();
export default logService;
